export enum ContactType {
    returns = 'Returns',
    creditMemos = 'Credit Memos',
    purchaseOrderReports = 'Purchase Order Reports',
    purchaseOrderSubmitter = 'Purchase Order Submitter',
}
